export default __webpack_public_path__ + "img/pin_icons/biohazard_w.svg";